<div class="section-endpoints">
  <div class="label" *ngIf="label">{{ label }}</div>
  <ng-container *ngTemplateOutlet="headerTpl"></ng-container>
  <ng-container *ngIf="!busy; else busySpinner">
    <ng-container *ngFor="let company of companies; trackBy: trackByFn">
      <div class="item" *ngIf="company[side + '_settings'].length" (click)="onToggleState(company.id)">
        <div class="arrow" [@toggleArrow]="isClosed(company.id)">
          <i nz-icon nzType="ng-zorro:arrowDown" class="arrow-icon"></i>
        </div>
        <div class="title">
          {{ company.name }}
        </div>
      </div>
      <ng-container *ngIf="isClosed(company.id) === 'visible'">
        <div *ngFor="let endpoint of company[side + '_settings']; trackBy: trackByFn" class="item endpoint">
          <ng-container *ngTemplateOutlet="endpointTpl; context: { $implicit: endpoint }"></ng-container>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
  <ng-template #busySpinner>
    <img style="margin: 0 37%" src="/assets/img/spinner.gif" />
  </ng-template>
</div>
